import { getToken } from "../../helpers/common";
import * as apiService from "../api";
import * as API_URL from "../../constants/api";


export const getHodublastJobs = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.FETCH_HODUBLAST_JOBS, payload, token);
        return response;
    } catch (err) {
        console.log("Error in getHodublastJobs : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const addHodublastJobs = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.ADD_HODUBLAST_JOBS, payload, token);
        return response;
    } catch (err) {
        console.log("Error in getHodublastJobs : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}


export const deleteHodublastJob = async (payload) => {
    try {
        const token = getToken();
        const { id } = payload;
        const response = await apiService.deleteData(API_URL.DELETE_HODUBLAST_JOB + `/${id}`, token);
        return response;
    } catch (err) {
        console.log("Error in getHodublastJobs : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const getHodublastReportData = async (payload) => {
    try {
        const token = getToken();
        const response = await apiService.post(API_URL.FETCH_HODUBLAST_UPLOAD_REPORT, payload, token);
        return response;
    } catch (err) {
        console.log("Error in getHodublastReportData : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const exportHodublastDefaultersExportCSVFile = async (payload) => {
    try {
        const token = getToken();
        return await apiService.post(API_URL.EXPORT_HODUBLAST_UPLOAD_REPORT_CSV, payload, token);
    } catch (err) {
        console.log("Error in exportHodublastDefaultersExportCSVFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const addAdminTestContacts = async (payload) => {
    try {
        const token = getToken();
        return await apiService.post(API_URL.ADD_ADMIN_TEST_CONTACT_FOR_IVR, payload, token);
    } catch (err) {
        console.log("Error in exportHodublastDefaultersExportCSVFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}


export const getAdminTestContacts = async (payload) => {
    try {
        const token = getToken();
        const { campaign_id } = payload;
        if (!campaign_id) {
            return {
                success: false,
                message: "Campaign_id is required",
                data: [],
            }
        }
        return await apiService.get(API_URL.GET_ADMIN_TEST_CONTACTS_FOR_IVR + `/${campaign_id}`, token);
    } catch (err) {
        console.log("Error in exportHodublastDefaultersExportCSVFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}


export const deleteAdminTestContact = async (payload) => {
    try {
        const token = getToken();
        const { campaign_id, contact_number } = payload;
        if (!campaign_id || !contact_number) {
            return {
                success: false,
                message: "Campaign_id or contact_number is Missing!",
                data: [],
            }
        }
        return await apiService.post(API_URL.DELETE_ADMIN_TEST_CONTACTS_FOR_IVR, payload, token);
    } catch (err) {
        console.log("Error in exportHodublastDefaultersExportCSVFile : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}

export const fetchAllHodublastJobs = async (payload) => {
    try {
        const token = getToken();
        return await apiService.post(API_URL.FETCH_ALL_HODUBLAST_JOBS, payload, token);
    } catch (err) {
        console.log("Error in fetchAllHodublastJobs : ", err);
        return { success: false, message: err?.message || "Something went wrong!", data: [] };
    }
}